<template>
  <path
    d="M21 4.00024H3C1.9 4.00024 1 4.90024 1 6.00024V18.0002C1 19.1002 1.9 20.0002 3 20.0002H21C22.1 20.0002 22.99 19.1002 22.99 18.0002L23 6.00024C23 4.90024 22.1 4.00024 21 4.00024ZM19 18.0002H5V6.00024H19V18.0002Z"
  />
</template>
